// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-RoutingResult-module__resultRow {
    border-bottom: 1px lightgray solid;
}

.src-sidebar-RoutingResult-module__resultSelectableArea {
    padding: 1rem 0;
    border-left: white solid 0.25rem;
}

.src-sidebar-RoutingResult-module__resultSelectableArea:hover .src-sidebar-RoutingResult-module__resultSummary {
    border-left: rgba(201, 217, 241, 0.7) solid 0.25rem;
    padding: 0 1rem 0 15px;
}

.src-sidebar-RoutingResult-module__resultSummary {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 1rem 0 15px;
    border-left: white solid 0.25rem;
}

.src-sidebar-RoutingResult-module__selectedResultSummary {
    border-left: rgba(39, 100, 200, 0.85) solid 0.25rem !important;
    padding: 0 1rem 0 15px;
}

.src-sidebar-RoutingResult-module__resultValues {
    cursor: pointer;
    width: 50%;

    display: flex;
    flex-direction: column;
}

.src-sidebar-RoutingResult-module__resultMainText {
    font-size: large;
    font-weight: bold;
    margin-bottom: 0.1rem;
}

.src-sidebar-RoutingResult-module__resultSecondaryText,
.src-sidebar-RoutingResult-module__exportButton div,
.src-sidebar-RoutingResult-module__elevationHint {
    color: #5b616a;
}

.src-sidebar-RoutingResult-module__resultTertiaryText {
    color: #5b616a;
    font-size: 12px;
}

.src-sidebar-RoutingResult-module__detailsButton,
.src-sidebar-RoutingResult-module__exportButton {
    padding-top: 1px; /* correction for "height: auto" of svg  */
}

.src-sidebar-RoutingResult-module__detailsButton div,
.src-sidebar-RoutingResult-module__detailsButtonExpanded div,
.src-sidebar-RoutingResult-module__exportButton div {
    color: #5b616a;
    font-size: 12px;
    float: left;
    padding-top: 0.15em;
    padding-left: 0.5em;
}

.src-sidebar-RoutingResult-module__detailsButton svg,
.src-sidebar-RoutingResult-module__detailsButtonExpanded svg,
.src-sidebar-RoutingResult-module__exportButton svg {
    float: left;
    width: 1.2em;
    height: auto;
}

.src-sidebar-RoutingResult-module__exportButton:active div,
.src-sidebar-RoutingResult-module__detailsButton:active div,
.src-sidebar-RoutingResult-module__detailsButtonExpanded:active div {
    color: lightgray;
}

.src-sidebar-RoutingResult-module__detailsButton:active svg path,
.src-sidebar-RoutingResult-module__exportButton:active svg path,
.src-sidebar-RoutingResult-module__detailsButtonExpanded:active svg path {
    fill: lightgray;
}

.src-sidebar-RoutingResult-module__exportButton:hover div,
.src-sidebar-RoutingResult-module__detailsButton:hover div,
.src-sidebar-RoutingResult-module__detailsButtonExpanded:hover div {
    color: black;
}

.src-sidebar-RoutingResult-module__detailsButton:hover svg path,
.src-sidebar-RoutingResult-module__exportButton:hover svg path,
.src-sidebar-RoutingResult-module__detailsButtonExpanded:hover svg path {
    fill: black;
}

.src-sidebar-RoutingResult-module__detailsButton svg path,
.src-sidebar-RoutingResult-module__exportButton svg path {
    fill: #5b616a;
    stroke: #5b616a;
}

.src-sidebar-RoutingResult-module__placeholderContainer {
    margin: 1.08rem 1rem;
}

.src-sidebar-RoutingResult-module__placeholderMain {
    height: 1.25rem;
    width: 7rem;
    background-color: lightgray;
    margin-bottom: 0.5rem;
    border-radius: 0.2rem;
    animation-name: src-sidebar-RoutingResult-module__pulse;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.src-sidebar-RoutingResult-module__placeholderSecondary {
    height: 1rem;
    width: 5rem;
    margin-bottom: 0;
    animation-delay: 0.25s;
}

@keyframes src-sidebar-RoutingResult-module__pulse {
    from {
        opacity: 0.5;
    }
    to {
        opacity: 1;
    }
}

.src-sidebar-RoutingResult-module__routeHints div {
    padding: 0 1.5em 0.2em 1.4em;
}

.src-sidebar-RoutingResult-module__routeHints div {
    font-size: small;
    color: #383838;
}

.src-sidebar-RoutingResult-module__routeHints {
    margin-top: -0.3rem;
    padding-bottom: 0.2em;
}

.src-sidebar-RoutingResult-module__routeHints .src-sidebar-RoutingResult-module__icons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 8px;
    padding-bottom: 0.5rem;
}

.src-sidebar-RoutingResult-module__routeHintButton span,
.src-sidebar-RoutingResult-module__selectedRouteHintButton span {
    font-size: xx-small;
}

.src-sidebar-RoutingResult-module__routeHintButton,
.src-sidebar-RoutingResult-module__selectedRouteHintButton {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 50px;
    padding: 2px 4px;
    border: 1px solid transparent; /* make border visible on hover or for selected */
    transition: border-color 0.5s ease;
}

.src-sidebar-RoutingResult-module__routeHintButton:hover {
    border-color: #bebebe;
}

.src-sidebar-RoutingResult-module__routeHintButton:hover,
.src-sidebar-RoutingResult-module__selectedRouteHintButton:hover,
.src-sidebar-RoutingResult-module__routeHintButton:hover span {
    color: black;
}

.src-sidebar-RoutingResult-module__routeHintButton,
.src-sidebar-RoutingResult-module__routeHintButton span {
    color: gray;
    padding-top: 1px;
}

.src-sidebar-RoutingResult-module__selectedRouteHintButton,
.src-sidebar-RoutingResult-module__selectedRouteHintButton span {
    color: #383838;
    padding-top: 1px;
    border-color: #d5d4d4;
}

.src-sidebar-RoutingResult-module__routingResultRoadData {
    color: gray;
    font-size: small;
    padding: 10px 5px 10px 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/RoutingResult.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mDAAmD;IACnD,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,8DAA8D;IAC9D,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,UAAU;;IAEV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,gBAAgB,EAAE,0CAA0C;AAChE;;AAEA;;;IAGI,cAAc;IACd,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,qBAAqB;IACrB,qBAAqB;IACrB,uDAAqB;IACrB,sBAAsB;IACtB,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B,EAAE,iDAAiD;IAChF,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;AAC/B","sourcesContent":[".resultRow {\n    border-bottom: 1px lightgray solid;\n}\n\n.resultSelectableArea {\n    padding: 1rem 0;\n    border-left: white solid 0.25rem;\n}\n\n.resultSelectableArea:hover .resultSummary {\n    border-left: rgba(201, 217, 241, 0.7) solid 0.25rem;\n    padding: 0 1rem 0 15px;\n}\n\n.resultSummary {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 0 1rem 0 15px;\n    border-left: white solid 0.25rem;\n}\n\n.selectedResultSummary {\n    border-left: rgba(39, 100, 200, 0.85) solid 0.25rem !important;\n    padding: 0 1rem 0 15px;\n}\n\n.resultValues {\n    cursor: pointer;\n    width: 50%;\n\n    display: flex;\n    flex-direction: column;\n}\n\n.resultMainText {\n    font-size: large;\n    font-weight: bold;\n    margin-bottom: 0.1rem;\n}\n\n.resultSecondaryText,\n.exportButton div,\n.elevationHint {\n    color: #5b616a;\n}\n\n.resultTertiaryText {\n    color: #5b616a;\n    font-size: 12px;\n}\n\n.detailsButton,\n.exportButton {\n    padding-top: 1px; /* correction for \"height: auto\" of svg  */\n}\n\n.detailsButton div,\n.detailsButtonExpanded div,\n.exportButton div {\n    color: #5b616a;\n    font-size: 12px;\n    float: left;\n    padding-top: 0.15em;\n    padding-left: 0.5em;\n}\n\n.detailsButton svg,\n.detailsButtonExpanded svg,\n.exportButton svg {\n    float: left;\n    width: 1.2em;\n    height: auto;\n}\n\n.exportButton:active div,\n.detailsButton:active div,\n.detailsButtonExpanded:active div {\n    color: lightgray;\n}\n\n.detailsButton:active svg path,\n.exportButton:active svg path,\n.detailsButtonExpanded:active svg path {\n    fill: lightgray;\n}\n\n.exportButton:hover div,\n.detailsButton:hover div,\n.detailsButtonExpanded:hover div {\n    color: black;\n}\n\n.detailsButton:hover svg path,\n.exportButton:hover svg path,\n.detailsButtonExpanded:hover svg path {\n    fill: black;\n}\n\n.detailsButton svg path,\n.exportButton svg path {\n    fill: #5b616a;\n    stroke: #5b616a;\n}\n\n.placeholderContainer {\n    margin: 1.08rem 1rem;\n}\n\n.placeholderMain {\n    height: 1.25rem;\n    width: 7rem;\n    background-color: lightgray;\n    margin-bottom: 0.5rem;\n    border-radius: 0.2rem;\n    animation-name: pulse;\n    animation-duration: 1s;\n    animation-iteration-count: infinite;\n    animation-direction: alternate;\n}\n\n.placeholderSecondary {\n    height: 1rem;\n    width: 5rem;\n    margin-bottom: 0;\n    animation-delay: 0.25s;\n}\n\n@keyframes pulse {\n    from {\n        opacity: 0.5;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.routeHints div {\n    padding: 0 1.5em 0.2em 1.4em;\n}\n\n.routeHints div {\n    font-size: small;\n    color: #383838;\n}\n\n.routeHints {\n    margin-top: -0.3rem;\n    padding-bottom: 0.2em;\n}\n\n.routeHints .icons {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    column-gap: 8px;\n    padding-bottom: 0.5rem;\n}\n\n.routeHintButton span,\n.selectedRouteHintButton span {\n    font-size: xx-small;\n}\n\n.routeHintButton,\n.selectedRouteHintButton {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 50px;\n    padding: 2px 4px;\n    border: 1px solid transparent; /* make border visible on hover or for selected */\n    transition: border-color 0.5s ease;\n}\n\n.routeHintButton:hover {\n    border-color: #bebebe;\n}\n\n.routeHintButton:hover,\n.selectedRouteHintButton:hover,\n.routeHintButton:hover span {\n    color: black;\n}\n\n.routeHintButton,\n.routeHintButton span {\n    color: gray;\n    padding-top: 1px;\n}\n\n.selectedRouteHintButton,\n.selectedRouteHintButton span {\n    color: #383838;\n    padding-top: 1px;\n    border-color: #d5d4d4;\n}\n\n.routingResultRoadData {\n    color: gray;\n    font-size: small;\n    padding: 10px 5px 10px 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultRow": `src-sidebar-RoutingResult-module__resultRow`,
	"resultSelectableArea": `src-sidebar-RoutingResult-module__resultSelectableArea`,
	"resultSummary": `src-sidebar-RoutingResult-module__resultSummary`,
	"selectedResultSummary": `src-sidebar-RoutingResult-module__selectedResultSummary`,
	"resultValues": `src-sidebar-RoutingResult-module__resultValues`,
	"resultMainText": `src-sidebar-RoutingResult-module__resultMainText`,
	"resultSecondaryText": `src-sidebar-RoutingResult-module__resultSecondaryText`,
	"exportButton": `src-sidebar-RoutingResult-module__exportButton`,
	"elevationHint": `src-sidebar-RoutingResult-module__elevationHint`,
	"resultTertiaryText": `src-sidebar-RoutingResult-module__resultTertiaryText`,
	"detailsButton": `src-sidebar-RoutingResult-module__detailsButton`,
	"detailsButtonExpanded": `src-sidebar-RoutingResult-module__detailsButtonExpanded`,
	"placeholderContainer": `src-sidebar-RoutingResult-module__placeholderContainer`,
	"placeholderMain": `src-sidebar-RoutingResult-module__placeholderMain`,
	"pulse": `src-sidebar-RoutingResult-module__pulse`,
	"placeholderSecondary": `src-sidebar-RoutingResult-module__placeholderSecondary`,
	"routeHints": `src-sidebar-RoutingResult-module__routeHints`,
	"icons": `src-sidebar-RoutingResult-module__icons`,
	"routeHintButton": `src-sidebar-RoutingResult-module__routeHintButton`,
	"selectedRouteHintButton": `src-sidebar-RoutingResult-module__selectedRouteHintButton`,
	"routingResultRoadData": `src-sidebar-RoutingResult-module__routingResultRoadData`
};
export default ___CSS_LOADER_EXPORT___;
